/**
 * Created by Jie Gao on 2019-09-20.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {DragonTribeGameConfig} from "../../DragonTribeGameConfig";
import {DragonTribeSoundConfig} from "../../DragonTribeSoundConfig";

export class Plus2SpinsView extends BaseView {
    private _layer:PIXI.Container;
    protected _plus2Spins:PIXI.Sprite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(DragonTribeGameConfig.instance.LAYERS.FOREGROUND.name);
    }

    protected initAnimations():void {
        this._plus2Spins = new PIXI.Sprite(GameResources.getTextures("plus2spins")[0]);
        this._plus2Spins.anchor.set(0.5, 0.5);
        this._plus2Spins.position.set(DragonTribeGameConfig.instance.GAME_WIDTH * 0.5, DragonTribeGameConfig.instance.GAME_HEIGHT * 0.5);
    }

    public show(freespinsLeft:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const fs:number = 0.033;
        tl.add([
            () => {
                this._layer.addChild(this._plus2Spins);
                this._plus2Spins.alpha = 1;
                SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_PLUS);
            },
            TweenLite.fromTo(this._plus2Spins.scale, 6 * fs, {x : 0.7, y : 0.7}, {x : 1, y : 1})
        ]);
        tl.add(() => SlotGame.keypad.setZeroBetSpinCounter(freespinsLeft));
        tl.add(TweenLite.to(this._plus2Spins, 20 * fs, {alpha : 1}));
        tl.add(TweenLite.to(this._plus2Spins, 6 * fs, {alpha : 0}));
        tl.add(() => {this.hide();});
        return tl;
    }

    public hide():void {
        this.removeChild(this._plus2Spins);
        this._plus2Spins.alpha = 0;
    }
}